// cw-bottom-bar.js
(function () {
    // Helper: wait for element
    function waitForElement(selector, timer = 30000, frequency = 100) {
        return new Promise((resolve, reject) => {
        const el = document.querySelector(selector);
        if (timer <= 0) return reject(`waitForElement | Couldn't find element with selector: ${selector}`);
        if (el) return resolve(el);
        setTimeout(() => {
            waitForElement(selector, timer - frequency, frequency).then(resolve).catch(reject);
        }, frequency);
        });
    }

    const selectors = {
        charSrc: ".product-characteristics__container",
        atcSrc: "[data-add-to-cart]",
        target: ".product-content__sticky .product-block:has([data-add-to-cart])",
        teaser: '[data-testid="animated-teaser"]'
    };
    Promise.all([
        waitForElement(selectors.atcSrc),
        waitForElement(selectors.target),
        waitForElement(selectors.teaser)
    ]).then(([atcSrc, targetEl, teaserEl]) => {
        const charSrc = document.querySelector('.product-characteristics__container');
        const bar = document.createElement("div");
        bar.className = "cw-bottom-bar new-page-content--product";
        const charClone = charSrc ? charSrc.cloneNode(true) : '';
        const atcClone = atcSrc.cloneNode(true);
        charSrc && (bar.append(charClone));
        bar.append(atcClone);
        document.body.appendChild(bar);

        const teaser = teaserEl.closest('div.needsclick[role="button"][tabindex="0"]') || teaserEl;

        const computeOffset = () => -( (bar.getBoundingClientRect().height || 0) + 10 );
        const stripY = s => (s || '').replace(/\s*translateY\([^)]+\)/, '').trim();

        const applyTeaserShift = () => {
        const base = stripY(teaser.style.transform || getComputedStyle(teaser).transform);
        const y = bar.classList.contains('cw-show') ? computeOffset() : 0;
        teaser.style.transition = (teaser.style.transition?.includes('transform')
            ? teaser.style.transition
            : (teaser.style.transition ? teaser.style.transition + ', ' : '') + 'transform .3s ease');
        teaser.style.transform = (base && base !== 'none' ? base + ' ' : '') + `translateY(${y}px)`;
        };

        new MutationObserver(applyTeaserShift).observe(bar, { attributes: true, attributeFilter: ['class'] });
        window.addEventListener('resize', applyTeaserShift);
        applyTeaserShift();


        const styleEl = document.createElement("style");
        styleEl.id = "cw-bottom-bar-style";
        styleEl.textContent =
            ".cw-bottom-bar{position:fixed;left:0;bottom:0;width:100%;z-index:9999;background:#fff;box-shadow:0 -4px 12px rgba(0,0,0,.15);transform:translateY(100%);transition:transform .35s ease}.cw-bottom-bar.cw-show{transform:translateY(0)}";
        document.head.appendChild(styleEl);

        atcClone.addEventListener("click", e => {
            e.preventDefault();
            atcSrc.click();
        });

        const showBar = () => bar.classList.add("cw-show");
        const hideBar = () => bar.classList.remove("cw-show");
        const nearPageBottom = () =>
            document.documentElement.scrollHeight - (window.scrollY + window.innerHeight) <= 200;

        let targetInView = false;

        const io = new IntersectionObserver(entries => {
            targetInView = entries[0].isIntersecting;
            if (targetInView || nearPageBottom()) hideBar(); else showBar();
        }, { threshold: 0 });
        io.observe(targetEl);

        let ticking = false;
        window.addEventListener("scroll", () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    if (nearPageBottom()) hideBar();
                    else if (!targetInView) showBar();
                    else hideBar();
                    ticking = false;
                });
                ticking = true;
            }
        });
    });
})();

